import type { SVGProps } from 'react';
export const SvgFirstline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M11.667 3.75H17.5M11.667 7.917H17.5M2.5 12.083h15M2.5 16.25h15M7.917 7.025V4.64c0-.933-.375-1.308-1.317-1.308H4.225c-.933 0-1.308.375-1.308 1.308v2.375c0 .942.375 1.317 1.308 1.317H6.6c.942 0 1.317-.375 1.317-1.308"
		/>
	</svg>
);
